import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";

import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import AdminAjoutFournisseur from "./AdminAjoutFournisseur";

const API_URL = process.env.REACT_APP_API_URL;

function ListeFournisseursVerres() {
  const [verriers, setVerriers] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    function getVerriers() {
      axios
        .get(`${API_URL}/api/verriers`)
        .then((res) => res.data)
        .then((data) => {
          setVerriers(data);
        });
    }

    getVerriers();
  }, []);

  let lettrePrecedente = "";

  return (
    <div className="listeMain">
      <h1>Gestion des verriers</h1>
      <MDBBtn type="button" outline color="primary" onClick={handleShow}>
        Ajouter un verrier
      </MDBBtn>
      <ul>
        {verriers ? (
          verriers.map((verrier) => {
            if (verrier.nom.charAt(0).toUpperCase() !== lettrePrecedente) {
              lettrePrecedente = verrier.nom.charAt(0).toUpperCase();
              return (
                <div>
                  <div className="initial">{lettrePrecedente}</div>
                  <ul className="firstAfterInitial">
                    <li key={verrier.id}>
                      <Link to={`/admin-fournisseurs-verres/${verrier.id}`}>
                        {verrier.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            } else {
              return (
                <div>
                  <ul>
                    <li key={verrier.id}>
                      <Link to={`/admin-fournisseurs-verres/${verrier.id}`}>
                        {verrier.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            }
          })
        ) : (
          <li>Loading</li>
        )}
      </ul>
      <MDBContainer>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Créer un fournisseur </MDBModalHeader>
          <MDBModalBody>
            <AdminAjoutFournisseur category="verriers" />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default ListeFournisseursVerres;
